module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('div', {
    staticClass: "img_container0"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fig1.jpg"
    }
  })])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('h2', {
    staticClass: "illu"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('em', {
    staticClass: "italic"
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Illustrations")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "noteZ"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "spaceZ"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Illustrations#page_8"
    }
  }, [_vm._v("Page 8")]), _vm._v(". Detail from White Mouse and Green Cabbage, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "noteZ"
  }, [_c('span', {
    staticClass: "spaceZ"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Origin#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 18")]), _vm._v(".")]), _vm._v(" Detail from The Moon Like a Pearl, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "noteZ"
  }, [_c('span', {
    staticClass: "spaceZ"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Use_This_Book#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 22")]), _vm._v(".")]), _vm._v(" Detail from A Thousand Years of Happiness, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "top"
  }), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu1",
      "id": "illu1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(".")]), _vm._v(" Summer Day, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu2",
      "id": "illu2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(".")]), _vm._v(" Cloud Dragon, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu3",
      "id": "illu3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(".")]), _vm._v(" The Exasperation of Daily Life, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu4",
      "id": "illu4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(".")]), _vm._v(" True Independence, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu5",
      "id": "illu5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(".")]), _vm._v(" Taoist Riding the Tiger, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu6",
      "id": "illu6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(".")]), _vm._v(" That Look! 2010")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu7",
      "id": "illu7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(".")]), _vm._v(" A Word to My Admirers, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu8",
      "id": "illu8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(".")]), _vm._v(" The Emperor of the World Arrives, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu9",
      "id": "illu9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(".")]), _vm._v(" Calligraphic Birds, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu10",
      "id": "illu10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(".")]), _vm._v(" Like Flowers by the River, 2001")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu11",
      "id": "illu11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(".")]), _vm._v(" A Collector of Fine Things, 2006")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu12",
      "id": "illu12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(".")]), _vm._v(" Deer Chasing a Cloud, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu13",
      "id": "illu13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(".")]), _vm._v(" Mount Fujisan, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu14",
      "id": "illu14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(".")]), _vm._v(" The Life of the Illiterate Hermit, 2005")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu15",
      "id": "illu15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(".")]), _vm._v(" Gordian Bird Sings Knot, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu16",
      "id": "illu16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(".")]), _vm._v(" Symbol of Success, 2006")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu17",
      "id": "illu17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(".")]), _vm._v(" Rooster Challenging a Rock, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu18",
      "id": "illu18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(".")]), _vm._v(" Sumo Wrestler, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu19",
      "id": "illu19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(".")]), _vm._v(" Light in All Directions, 1988")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu20",
      "id": "illu20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(".")]), _vm._v(" Between Heaven and Earth, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu21",
      "id": "illu21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(".")]), _vm._v(" Po-Mo (Splashed Ink), 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu22",
      "id": "illu22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(".")]), _vm._v(" “If You Blink You’ll Miss It,” 2008")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu23",
      "id": "illu23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(".")]), _vm._v(" Cézanne Meets Fan Kuan, 2005")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu24",
      "id": "illu24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(".")]), _vm._v(" Two Birds Uncertain about Heisenberg, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu25",
      "id": "illu25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(".")]), _vm._v(" Selflessness, 1998")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu26",
      "id": "illu26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(".")]), _vm._v(" The Last Chapter in the Life of an Insect, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu27",
      "id": "illu27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(".")]), _vm._v(" White Mouse and Green Cabbage, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu28",
      "id": "illu28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(".")]), _vm._v(" Like an Arrow Among Pines, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "notep"
  }, [_c('span', {
    staticClass: "space4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#rillu29",
      "id": "illu29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(".")]), _vm._v(" Emptiness and Bliss, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I")]), _vm._v(". Detail from Migrating Birds, 1996")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II")]), _vm._v(". Scholar Reading Under a Tree, 2006")]), _vm._v(" "), _c('p', {
    staticClass: "noteZ"
  }, [_c('span', {
    staticClass: "spaceZ"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_The_Author#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 97")]), _vm._v(".")]), _vm._v(" Portrait of Tamarack Song, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "noteZ"
  }, [_c('span', {
    staticClass: "spaceZ"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_The_Artist#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 99")]), _vm._v(".")]), _vm._v(" Selfportrait of the Artist at Work, 2006")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The Chinese terms found herein are Standard Mandarin, also known as Pǔtōnghuà (or Common Speech, 普通話) in the People’s Republic of China (PRC), where it is the official language. Latin alphabet transliterations are in the pīnyīn system (拼音), which since its development in 1958 by the PRC has gradually replaced Wade-Giles (in use since the late 1800s) to become the international standard. Wade-Giles terms still in common usage appear in parentheses after the pīnyīn. Of the two standard sets of Chinese characters, simplified (簡體中文) and traditional (繁體中文), this text employs traditional.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dc31f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Illustrations.vue
// module id = 75
// module chunks = 0